export const Graphs = () => (
  <>
    <h3>Available Graphs</h3>
    <p>
      The following graphs are created for each optimized assay:
      <ul>
        <li>barchart of the modeled fatty acid profile</li>
        <li>history of the modeled fatty acid profile during the optimization</li>
        <li>dot plot for the modeled and the target lipid profile</li>
      </ul>
    </p>

    <h4>Interactivity</h4>
    <p>
      <ul>
        <li>
          Upon hovering over any bar in the bar chart or line in the optimization history plot, 
          the corresponding fatty acid is highlighted in both plots.
        </li>
        <li>
          Upon hovering over any dot in the dot plots a tooltip showing the lipid species and its percentage is displayed.
        </li>
        <li>
          Upon clicking on any dot in the dot plots, the tooltip is fixed. To unlock, click the dot again.
        </li>
        <li>
          The slider below the graphs allows adjusting a cut off for low abundant species to filter them out of the visualizations.
        </li>
      </ul>
    </p>
  </>
)
